import { render, staticRenderFns } from "./PartyCategory.vue?vue&type=template&id=4b56c6a8&scoped=true"
import script from "./PartyCategory.vue?vue&type=script&lang=js"
export * from "./PartyCategory.vue?vue&type=script&lang=js"
import style0 from "./PartyCategory.vue?vue&type=style&index=0&id=4b56c6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b56c6a8",
  null
  
)

export default component.exports